import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class RealtimeDatabaseService {

  constructor(
    private afDatabase: AngularFireDatabase,
    private firebaseAuth: AngularFireAuth,
  ) {

  }

  getUserBalance(): Observable<any> {
    return this.firebaseAuth.authState.pipe(mergeMap((user) => {
      return this.afDatabase.list('wallets/' + user?.uid).valueChanges();
    }));
  }
}
